import React from "react";

export default function UserDropdown({ user, onLogout }) {
  return (
    <div className="dropdown">
      <button
        className="btn border-0 d-flex align-items-center"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <img
          src={user?.avatar || "../../../public/pig.png"}
          alt="avatar"
          className="rounded-circle me-2"
          width="36"
          height="36"
        />
        <span
          className="fw-semibold text-truncate d-inline-block"
          style={{ maxWidth: "150px" }}
        >
          {user?.name || "User"}
        </span>
        <i className="bi bi-caret-down-fill ms-1"></i>
      </button>

      <ul className="dropdown-menu dropdown-menu-end shadow-sm">

        <li>
          <h6 className="dropdown-header">Tài khoản</h6>
        </li>

        <li>
          <button className="dropdown-item">
            <i className="bi bi-person-fill me-2"></i>
            Thông tin cá nhân
          </button>
        </li>

        <li>
          <button className="dropdown-item">
            <i className="bi bi-gear-fill me-2"></i>
            Cài đặt
          </button>
        </li>

        <li><hr className="dropdown-divider" /></li>

        <li>
          <button
            className="dropdown-item text-danger"
            onClick={onLogout}
          >
            <i className="bi bi-box-arrow-right me-2"></i>
            Đăng xuất
          </button>
        </li>

      </ul>
    </div>
  );
}
